import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import styles from './styles.module.scss';

const ClustererContentLayout = (ymaps) =>
	ymaps.templateLayoutFactory.createClass(
		renderToStaticMarkup(
			<div className={styles.Clusterer}>
				{'{{ properties.geoObjects.length }}'}
			</div>
		)
	);

export default ClustererContentLayout;
